import MxInputThousandField, {
  MxInputThousandFieldProps
} from "@rf-l1/form/text-fields/MxInputThousandField";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";

type omit = "name" | "onChange";
export type MxFormTextThousandFieldProps = Omit<MxInputThousandFieldProps, omit>;
const MxFormTextThousandField = (props: MxFormTextThousandFieldProps) => {
  const { invalid, onChange, id, onBlur, name, value, required } =
    useMxFieldControllerContext();

  return (
    <MxInputThousandField
      {...props}
      id={id}
      onChange={onChange}
      name={name}
      onBlur={onBlur}
      error={invalid}
      value={value}
      required={required}
      disabled={props.disabled}
    />
  );
};

export default MxFormTextThousandField;
